export class QueryCostDataRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "costUnit",
            "baseName": "costUnit",
            "type": "CostUnit",
            "format": ""
        },
        {
            "name": "usageUnit",
            "baseName": "usageUnit",
            "type": "UsageUnit",
            "format": ""
        },
        {
            "name": "timeFrame",
            "baseName": "timeFrame",
            "type": "TimeFrame",
            "format": ""
        },
        {
            "name": "granularity",
            "baseName": "granularity",
            "type": "CostGranularity",
            "format": ""
        },
        {
            "name": "filters",
            "baseName": "filters",
            "type": "CostDataFilters",
            "format": ""
        },
        {
            "name": "groupBy",
            "baseName": "groupBy",
            "type": "CostDataGroupBy",
            "format": ""
        },
        {
            "name": "topN",
            "baseName": "topN",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QueryCostDataRequest.attributeTypeMap;
    }
    constructor() {
    }
}
